import React from 'react';
export var ContentTag;
(function (ContentTag) {
    ContentTag["H1"] = "h1";
    ContentTag["H2"] = "h2";
    ContentTag["H3"] = "h3";
    ContentTag["H4"] = "h4";
    ContentTag["H5"] = "h5";
    ContentTag["H6"] = "h6";
    ContentTag["P"] = "p";
    ContentTag["LI"] = "li";
    ContentTag["TD"] = "td";
    ContentTag["TH"] = "th";
    ContentTag["LABEL"] = "label";
    ContentTag["SPAN"] = "span";
})(ContentTag || (ContentTag = {}));
const Element = (props) => {
    const { type = ContentTag.P, className, children, htmlFor } = props;
    return React.createElement(type, { className, htmlFor }, children);
};
export default Element;
//# sourceMappingURL=Element.js.map